export default function (context, inject) {
  const config = {
  "metadatas": {
    "name": "CARGLASS® RADIO",
    "webappThemeColor": "#E31F18",
    "lang": "fr-FR",
    "charset": "utf-8",
    "colorPrimary": "#E31F18",
    "colorAccent": "#ededed",
    "colorSecondary": "#ff8f00",
    "colorInfo": "#26a69a",
    "colorWarning": "#ffc107",
    "colorError": "#dd2c00",
    "colorSuccess": "#00e676",
    "iconFileName": "icon.png",
    "iconProperties": {},
    "supportEmailAddress": "digital@mediameeting.fr",
    "siteHeadTitle": "CARGLASS® RADIO",
    "appName": "CARGLASS® RADIO",
    "webappFonts": {
      "families": {
        "Lato": [
          300,
          400,
          500,
          700
        ],
        "Rubik": [
          300,
          400,
          500
        ],
        "Roboto": [
          300,
          400,
          500,
          700
        ],
        "Merriweather": [
          300,
          400,
          500
        ]
      },
      "download": true,
      "outputDir": "static/fonts/google",
      "fontsPath": "~static/fonts/google/fonts"
    }
  }
}
  const metadatas = config.metadatas

  inject('metadatas', config.metadatas)
}
